<ng-lottie
  height="400px"
  [options]="options"
  *ngIf="!loaded"
></ng-lottie>
<ng-lottie
  height="400px"
  [options]="fileDropOptions"
  [style.opacity] = "fileBeingDropped? '100%' : '0%'"
  style="position: absolute;top: 0;pointer-events:none;"
></ng-lottie>
<div class="fileExplorerContainer" (contextmenu)="onRightClick($event)" [style.background] = "backgroundColor" [style.opacity] = "loaded? '100%' : '0%'">
  <div class="FileNav">
    <app-folder [folders]="folders" (newItemEvent)="folderSelected($event)" [indent]="0" [init]="true" [events]="eventsSubject.asObservable()"></app-folder>
  </div>
  <div class="NavBar rounded-top rounded-left">
    <div style="align-items: center; display: flex;">
    <button type="button" class="btn btn-primary" style="margin: 5px;" (click)="onNewFolder()"><i class="fas fa-plus"></i>&nbsp; Add Folder</button>
    <button type="button" class="btn btn-primary" style="margin: 5px;" (click)="onUpload()"><i class="fas fa-upload"></i>&nbsp;Upload</button>
    <button type="button" class="btn btn-primary" style="margin: 5px;" (click)="downloadFolderBtn()"><i class="fas fa-download"></i>&nbsp;Download All</button>
  </div>
  </div>
  <div class="Filter rounded-bottom">
    <div style="float: right;margin: 5px;">
      Filter By: <input (input)="onSearch(search.value)" #search>
    </div>
  </div>
  <div class="FileExplorer">
    <table style="width:100%">
      <tr>
        <th>File Name</th>
        <th>Size</th>
        <th>Created By</th>
        <th>Date</th>
      </tr>
      <tr class="File" *ngFor="let file of files| search:'FileName':searchQuery;" (click)="fileClicked(file.FileId)" (dblclick)="fileDblClicked(file.FileId, file.FileName)">
        <td>{{file.FileName}}</td>
        <td>{{file.Size}}</td>
        <td>{{file.CreatedBy}}</td>
        <td>{{moment(moment.utc(file.CreatedDate)).local().format("MMMM Do YYYY, h:mm a")}}</td>
      </tr>
    </table>
  </div>
</div>
